import GModal from "components/ui/modal/Modal";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Box, Flex, Stack, useToast } from "@chakra-ui/react";
import { useForm } from "react-hook-form";
import GButton from "components/ui/button/Button";
import MultiSelect from "components/ui/multiSelect/MultiSelect";
import { useDispatch, useSelector } from "react-redux";
import {
  getInvItemDrop,
  addTranOrderItems,
  getTranOrderItems,
  getTransfersOrdersDetails,
} from "../../services/transfersOrdersService";

const AddTOItemsModal = ({ onClose, id }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const toast = useToast({
    position: "top",
    duration: 3000,
    status: "success",
  });
  const toast2 = useToast({ position: "top", duration: 3000, status: "error" });
  const { handleSubmit, setValue } = useForm();

  const TransferOrdersId = id.TransferOrdersId;

  const productionsData = useSelector((state) => state.transfersorders);

  useEffect(() => {
    dispatch(getInvItemDrop());
  }, [dispatch]);

  return (
    <GModal
      onClose={onClose}
      modalHeader={t("pages.transfers_orders.items")}
      modalContent={
        <Box p={4}>
          <form
            onSubmit={handleSubmit((values) => {
              values.UserId = localStorage.getItem("userId");
              if (
                values.TransferOrders === undefined ||
                values.TransferOrders.length === 0
              ) {
                toast2({ description: t("validation.choose_first") });
              } else {
                values.TransferOrders = values.TransferOrders?.map((el) => ({
                  InventoryItemId: el.InventoryItemId,
                  TransferOrdersId,
                }));
                dispatch(addTranOrderItems(values))
                  .unwrap()
                  .then((_) => {
                    toast({
                      description: t("pages.transfers_orders.items_added"),
                    });
                    dispatch(getTranOrderItems(id));
                    dispatch(getTransfersOrdersDetails(id));
                    onClose();
                  });
              }
            })}
          >
            <Stack spacing={6}>
              <MultiSelect
                title={t("general.items")}
                data={productionsData.DropData1.map((el) => ({
                  ...el,
                  label: el.InventoryItemNameEng,
                  value: el.InventoryItemId,
                }))}
                isMulti={true}
                isRequired={true}
                onChange={(e) => setValue("TransferOrders", e)}
              />

              <Flex gap={4}>
                <GButton
                  type="submit"
                  title={t("general.save")}
                  bg="primary"
                  color="light"
                  border="1px solid transparent"
                  hover={{
                    color: "primary",
                    borderColor: "primary",
                    bg: "none",
                  }}
                />
                <GButton
                  title={t("general.close")}
                  onClick={onClose}
                  bg="red.600"
                  border="1px solid transparent"
                  color="light"
                  hover={{
                    color: "red.600",
                    borderColor: "red.600",
                    bg: "none",
                  }}
                />
              </Flex>
            </Stack>
          </form>
        </Box>
      }
    />
  );
};

export default AddTOItemsModal;
